import { ValidationResult } from "../types";
function hasUnitPrices(choices) {
    return choices.some((choice) => (choice.unitListPrice ?? 0) !== 0 || (choice.unitDiscountedPrice ?? 0) !== 0);
}
function hasListPrices(choices) {
    return choices.some((choice) => (choice.totalListPrice ?? 0) !== 0 || (choice.totalDiscountedPrice ?? 0) !== 0);
}
function hasDifferentialUnitPrices(choices) {
    return choices.some((choice) => (choice.differentialUnitListPrice ?? 0) !== 0 ||
        (choice.differentialUnitDiscountPrice ?? 0) !== 0);
}
function hasDifferentialListPrices(choices) {
    return choices.some((choice) => (choice.differentialListPrice ?? 0) !== 0 || (choice.differentialDiscountPrice ?? 0) !== 0);
}
export function priceDisplayModeValidator(productOption, priceDisplayMode) {
    const result = new ValidationResult();
    let outHidePrices = "differential-unit";
    if (priceDisplayMode === "none") {
        outHidePrices = "none";
    }
    else if (priceDisplayMode === "differential-unit") {
        if (productOption.key === "Quantity" && productOption.style === "dropdown") {
            // quantity product option should show unit prices
            if (hasUnitPrices(productOption.choices)) {
                result.addValidation("Quantity should display 'Unit' prices. 'differential-unit' was changed to 'unit'");
                outHidePrices = "unit";
            }
            else {
                result.addValidation("Quantity should display 'Unit' prices, but there are no unit prices to display. 'differential-unit' was changed to 'none'");
                outHidePrices = "none";
            }
        }
        else {
            if (hasDifferentialUnitPrices(productOption.choices)) {
                outHidePrices = "differential-unit";
            }
            else {
                result.addValidation("None of the choices have unit differential prices. Prices will not be shown.");
                outHidePrices = "none";
            }
        }
    }
    else if (priceDisplayMode === "differential-total") {
        if (productOption.key === "Quantity" && hasListPrices(productOption.choices)) {
            // quantity product option should show total prices
            result.addValidation("Quantity should display 'Total' prices. 'differential-total' was changed to 'total'");
            outHidePrices = "total";
        }
        else if (hasDifferentialListPrices(productOption.choices)) {
            outHidePrices = "differential-total";
        }
        else {
            result.addValidation("None of the choices have total differential prices. Prices will not be shown.");
            outHidePrices = "none";
        }
    }
    else if (priceDisplayMode === "unit") {
        if (hasUnitPrices(productOption.choices)) {
            outHidePrices = "unit";
        }
        else {
            result.addValidation("None of the choices have unit prices. Prices will not be shown.");
            outHidePrices = "none";
        }
    }
    else if (priceDisplayMode === "total") {
        if (hasListPrices(productOption.choices)) {
            outHidePrices = "total";
        }
        else {
            result.addValidation("None of the choices have total prices. Prices will not be shown.");
            outHidePrices = "none";
        }
    }
    return {
        messages: result.messages,
        priceDisplayMode: outHidePrices,
    };
}
//# sourceMappingURL=price-display-mode-validator.js.map